






























































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { QuickStartGuide, QsgScreen, Node } from './types';
import SwQuickStartGuideNode from './components/sw-qsg-nodes.vue';
import SwQuickStartGuidePagination from './components/sw-qsg-pagination.vue';
import { namespace, State } from 'vuex-class';
import { SwQsgStoreState, OpenDropdownLightPayload } from '@/core/sw-qsg';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { RootStoreState } from '@/store';
import { CoreStoreState } from '@/core';
// import { GmsFtrMangementUsersStoreState } from '@/modules/fw-svc-gms/gms-ftr-management-users';

const cssPrefix = 'sw-quick-start-guide';
const qsgNamespace = namespace('SwQsgStoreStateModule');
// const userManagementModule = namespace('GmsFtrMangementUsersStoreStateModule');

@Component({
  components: {
    SwQuickStartGuidePagination,
    SwQuickStartGuideNode,
  },
})
export default class SwQuickStartGuide extends SwExtendedVue {
  cssPrefix = cssPrefix;
  qsgStatus: boolean = false;
  overlayShow: number = 0;
  nodes: Node[] = [];
  activeNodes: Node[] = [];
  currentPage: number = 1;
  componentKey: number = 0;
  totalPage: number = 1;
  startWatching: boolean = false;
  selectedScreen: QsgScreen | any = {};

  @Prop({ type: Object, required: true })
  quickStartGuide: QuickStartGuide;

  @qsgNamespace.State
  qsgDisplayStatus: SwQsgStoreState['qsgDisplayStatus'];

  @qsgNamespace.Mutation
  readonly openDropdownLight: VuexMappedMutation<OpenDropdownLightPayload>;

  @State((state: RootStoreState) => state.CoreStoreModule.qsgComponentId)
  readonly qsgComponentId: CoreStoreState['qsgComponentId'];
  /*
  @userManagementModule.State
  loggedInUserDetails: GmsFtrMangementUsersStoreState['loggedInUserDetails'];
  */
  /*
  @Getter
  readonly getQsgComponentId: string;
  */
 // @Watch('startWatching')

  @Watch('qsgDisplayStatus')
  qsgOpenCall() {
    this.qsgProcess('showGuide');
  }

  @Watch('$route', { immediate: true })
  onRouteSwitch(to: any) {  // tslint:disable-line
    this.screenDisplayed(this.quickStartGuide.screens);
    this.qsgProcess('checkLocalStorage');
  }

  @Watch('qsgComponentId')
  onQsgComponentChange() {
    this.qsgWatcherDisplay();
    this.qsgProcess('checkLocalStorage');
  }

  qsgWatcherDisplay() {
    if (this.qsgComponentId && this.startWatching) {
      if (this.selectedScreen.hasOwnProperty('nodes')) {
        this.nodes = this.selectedScreen.nodes.filter((obj: Node) => {
          return obj.component_name === this.qsgComponentId;
        });
        this.totalPage = this.totalPageCalc();
        this.qsgStatus = this.nodes.length > 0;
        this.filterNodes();
      } else {
        this.nodes = [];
        this.totalPage = this.totalPageCalc();
        this.qsgStatus = this.nodes.length > 0;
      }
    }
  }

  mounted() {
    // if (this.quickStartGuide.enable_qsg) {
    //   this.screenDisplayed(this.quickStartGuide.screens);
    // }
    this.overlayShow = 100;
    // this.overlayShow = 200;
    /*
    eventBus.$on('openQuickStartGuide', (selectedVal: string) => {
      this.qsgProcess(selectedVal);
    });
    */
    /*
    console.warn('mounted');  // tslint:disable-line
      setTimeout(() => {
        console.warn('qsgComponentId', this.qsgComponentId);  // tslint:disable-line
    },         3000);
    */
  }

  openQuickStartGuide(data: string) {
    this.qsgProcess(data);
  }

  qsgProcess(data: string) {
    if (data === 'checkLocalStorage') { // need to replace local storage with users api
      if (localStorage.getItem('isInsightsQSG') === 'NO') {
        this.qsgStatus = false;
      } else {
        this.qsgStatus = this.nodes.length > 0;
      }
    } else if (data === 'showGuide') {
      // this.qsgStatus = true;
      if (this.quickStartGuide.enable_qsg) {
        this.screenDisplayed(this.quickStartGuide.screens);
      }
    }  else if (data === 'closeGuide') {
      this.currentPage = 1;
      this.activeNodes = this.quickStartGuide.close_screen[0].nodes || [];
      this.forceRerender();
      // setTimeout(() => { this.qsgStatus = false; eventBus.$emit('openDropdownLight', true); }, 3500);   // close the qsg & close the dropdown
      setTimeout(() => { this.qsgStatus = false; this.openDropdownLight({ flag: false }); }, 3500);
    }
  }

  forceRerender() {
    this.componentKey += 1;
  }

  screenDisplayed(screens: QsgScreen[]) {
    this.selectedScreen = {};
    this.nodes = [];
    this.selectedScreen = screens.find((screen: QsgScreen) => {
      return screen.path_name.toLocaleLowerCase() === window.location.pathname.toLocaleLowerCase();
    });
    if (this.selectedScreen === undefined) {
      this.selectedScreen = {};
    }
    if (this.selectedScreen && Object.keys(this.selectedScreen).length > 0 && this.selectedScreen.qsgStoreCall) {
      // start watching
      this.startWatching = true;
      this.qsgWatcherDisplay();
    } else {
      this.startWatching = false;
      this.nodes = Object.keys(this.selectedScreen).length > 0 && this.selectedScreen.hasOwnProperty('nodes') ? this.selectedScreen.nodes : [];  //tslint:disable-line
      this.totalPage = this.totalPageCalc();
      this.qsgStatus = this.nodes.length > 0;
      this.filterNodes();
    }
  }

  totalPageCalc() {
    const pageSet = new Set();
    this.nodes.forEach((val: Node) => {
      pageSet.add(Number((/[\d]+$/).exec(val.page_id)));
    });
    return pageSet.size;
  }

  filterNodes() {
    this.activeNodes = this.nodes.filter((val: Node) => {
      return Number((/[\d]+$/).exec(val.page_id)) === this.currentPage;
    });
  }

  pageChangeHandle(value: number) {
    this.currentPage = value;
    this.forceRerender();
    this.filterNodes();
  }

  closeOverlay() {
    this.currentPage = 1;
    this.qsgStatus = false;
  }
}
